import store from '../store';
export default function setPortableDevice() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroidOrIOS = ((/android/i.test(userAgent)) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream));
    store.commit('setPortableDevice', isAndroidOrIOS)

}
